<template>
  <el-container class="body">
    <el-header>
      <div class="logo">
        <img style="width: 40px;height: 40px" v-if="!this.logoInfo.content" :src="require('../assets/img/logo/' + logoName)" />
        <img style="width: 40px;height: 40px" v-if="this.logoInfo.content" :src="$fileBaseUrl + 'x40/' + this.logoInfo.content" />
        <span>{{ compInfo.compName }} ● {{ this.logoInfo.name ? this.logoInfo.name : titleName }}</span>
      </div>
      <Header></Header>
    </el-header>
    <el-main>
      <div class="left">
        <el-aside width="200px">
          <Menu></Menu>
        </el-aside>
      </div>
      <div class="right">
        <div class="breadcrumb layout flex-none">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item v-for="(item, index) in breadcrumb" :key="item.path">
              <a v-if="index < breadcrumb.length - 1" @click="breadBack(index)" class="pointer">{{ item.title }}</a>
              <span v-else>{{ item.title }}</span>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <keep-alive>
          <router-view class="flex main" v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view class="flex main" v-if="!$route.meta.keepAlive"></router-view>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import Header from "@/components/Header";
import Menu from "@/components/Menu.vue";
import { CacheService } from "@/service/common";
import { mapState } from "vuex";

export default {
  name: "Home",
  data() {
    return {
      nav: [],
      // eslint-disable-next-line no-undef
      titleName: titleName,
      // eslint-disable-next-line no-undef
      logoName: logoName,
      compInfo: "",
      //logo信息
      logoInfo: {},
    };
  },
  mounted() {
    this.nav = this.$router;
    this.compInfo = CacheService.get("comp") || {};
    this.getLogoInfo();
  },
  computed: mapState(["breadcrumb"]),
  watch: {
    breadcrumb(val) {},
  },
  methods: {
    breadBack(index) {
      const backLen = this.breadcrumb.length - index - 1;
      this.$router.go(-backLen);
    },
    //获取logo信息
    getLogoInfo() {
      this.$axios.get(`/OpencloudManager/Platform/PlatformConfigByKey?key=openPlatform&moduleType=1`).then((res) => {
        if (res) {
          this.logoInfo = res;
          if (this.logoInfo.name) {
            document.title = this.logoInfo.name;
          } else {
            document.title = this.titleName;
          }
        } else {
          document.title = this.titleName;
          this.logoInfo.content = "";
          this.logoInfo.name = "";
        }
      });
    },
  },
  components: {
    Menu,
    Header,
  },
};
</script>

<style scoped lang="scss">
.body {
  flex: 1;
  height: 100%;

  .logo {
    height: 44px;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    float: left;
    color: white;
    display: flex;
    align-items: center;

    img {
      margin-right: 10px;
    }
    span {
      font-size: 20px;
    }
  }

  .el-header {
    background: #282c34;
    box-shadow: 0 1px 4px 0 rgba(0, 21, 41, 0.12);
    padding: 0 20px;
  }

  .el-main {
    background: #f0f2f5;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    padding: 0;

    .left {
      .el-aside {
        background-color: #282c34;
        color: #ffffff;
        height: 100%;

        ::v-deep .el-menu {
          border-right: none;
        }
      }
    }

    .right {
      display: flex;
      flex-direction: column;
      width: 100%;
      overflow: hidden;
      margin: 20px;

      .breadcrumb {
        background: #fff;
        padding-left: 20px;
        line-height: 40px;
        height: 40px;
        margin-bottom: 10px;
        align-items: center;
        display: flex;
        font-size: 14px;
      }
    }

    .main {
      padding: 20px;
      background-color: #fff;
      flex: 1;
      overflow: auto;
      // overflow: hidden;
    }
  }
}

::v-deep .el-menu-item.is-active {
  background: #409eff !important;
}
</style>
